import { render, staticRenderFns } from "./DsResultsByRival.vue?vue&type=template&id=93f53076&scoped=true"
import script from "./DsResultsByRival.vue?vue&type=script&lang=js"
export * from "./DsResultsByRival.vue?vue&type=script&lang=js"
import style0 from "./DsResultsByRival.vue?vue&type=style&index=0&id=93f53076&prod&scoped=true&lang=scss"
import style1 from "./DsResultsByRival.vue?vue&type=style&index=1&id=93f53076&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f53076",
  null
  
)

export default component.exports